
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
$parcel$export(module.exports, "EventManager", function () { return $c3c0a900b033074b$export$cc74486daaaef499; });
"use strict";
var $c1a936bf11afc60d$exports = {};
"use strict";
var $c1a936bf11afc60d$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$c1a936bf11afc60d$exports = // eslint-disable-next-line es/no-global-this -- safe
$c1a936bf11afc60d$var$check(typeof globalThis == "object" && globalThis) || $c1a936bf11afc60d$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$c1a936bf11afc60d$var$check(typeof self == "object" && self) || $c1a936bf11afc60d$var$check(typeof $parcel$global == "object" && $parcel$global) || $c1a936bf11afc60d$var$check(typeof $c1a936bf11afc60d$exports == "object" && $c1a936bf11afc60d$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();


var $47e3a6f4aa64529d$exports = {};
"use strict";
var $871f3877c1fafb5a$exports = {};
"use strict";

$871f3877c1fafb5a$exports = $c1a936bf11afc60d$exports;


var $805b3d110a2de9fb$exports = {};
"use strict";
var $4ab7b62f7e4f8a95$exports = {};
"use strict";
var $9026b21e18613bf9$exports = {};
"use strict";
var $a33d963e09eb558c$exports = {};
"use strict";
$a33d963e09eb558c$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


$9026b21e18613bf9$exports = !$a33d963e09eb558c$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $4ab7b62f7e4f8a95$var$FunctionPrototype = Function.prototype;
var $4ab7b62f7e4f8a95$var$call = $4ab7b62f7e4f8a95$var$FunctionPrototype.call;
var $4ab7b62f7e4f8a95$var$uncurryThisWithBind = $9026b21e18613bf9$exports && $4ab7b62f7e4f8a95$var$FunctionPrototype.bind.bind($4ab7b62f7e4f8a95$var$call, $4ab7b62f7e4f8a95$var$call);
$4ab7b62f7e4f8a95$exports = $9026b21e18613bf9$exports ? $4ab7b62f7e4f8a95$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $4ab7b62f7e4f8a95$var$call.apply(fn, arguments);
    };
};


var $3334dd8de808f01a$exports = {};
"use strict";
var $41884dc45663552a$exports = {};
"use strict";
var $b6a15a94fe4eb57c$exports = {};
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$b6a15a94fe4eb57c$exports = function(it) {
    return it === null || it === undefined;
};


var $41884dc45663552a$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$41884dc45663552a$exports = function(it) {
    if ($b6a15a94fe4eb57c$exports(it)) throw new $41884dc45663552a$var$$TypeError("Can't call method on " + it);
    return it;
};


var $3334dd8de808f01a$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$3334dd8de808f01a$exports = function(argument) {
    return $3334dd8de808f01a$var$$Object($41884dc45663552a$exports(argument));
};


var $805b3d110a2de9fb$var$hasOwnProperty = $4ab7b62f7e4f8a95$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$805b3d110a2de9fb$exports = Object.hasOwn || function hasOwn(it, key) {
    return $805b3d110a2de9fb$var$hasOwnProperty($3334dd8de808f01a$exports(it), key);
};


var $ecd5b51bbe74d68a$export$2d1720544b23b823;
"use strict";
var $ca6d0bcc6f906075$exports = {};
"use strict";

var $6a3b62422cfbbb41$exports = {};
"use strict";
var $80fc1175d4e0e276$exports = {};
"use strict";
$80fc1175d4e0e276$exports = false;


var $7f4183893789d555$exports = {};
"use strict";

var $38d3933138a57991$exports = {};
"use strict";

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $38d3933138a57991$var$defineProperty = Object.defineProperty;
$38d3933138a57991$exports = function(key, value) {
    try {
        $38d3933138a57991$var$defineProperty($c1a936bf11afc60d$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $c1a936bf11afc60d$exports[key] = value;
    }
    return value;
};


var $7f4183893789d555$var$SHARED = "__core-js_shared__";
var $7f4183893789d555$var$store = $c1a936bf11afc60d$exports[$7f4183893789d555$var$SHARED] || $38d3933138a57991$exports($7f4183893789d555$var$SHARED, {});
$7f4183893789d555$exports = $7f4183893789d555$var$store;


($6a3b62422cfbbb41$exports = function(key, value) {
    return $7f4183893789d555$exports[key] || ($7f4183893789d555$exports[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.35.1",
    mode: $80fc1175d4e0e276$exports ? "pure" : "global",
    copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.35.1/LICENSE",
    source: "https://github.com/zloirock/core-js"
});



var $72fe204d9ae5bfe5$exports = {};
"use strict";

var $72fe204d9ae5bfe5$var$id = 0;
var $72fe204d9ae5bfe5$var$postfix = Math.random();
var $72fe204d9ae5bfe5$var$toString = $4ab7b62f7e4f8a95$exports(1.0.toString);
$72fe204d9ae5bfe5$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $72fe204d9ae5bfe5$var$toString(++$72fe204d9ae5bfe5$var$id + $72fe204d9ae5bfe5$var$postfix, 36);
};


var $f8b28deb16ab50c4$exports = {};
"use strict";
var $3036eed8c6059f48$exports = {};
"use strict";

var $03b2a56e52e979c9$exports = {};
"use strict";
$03b2a56e52e979c9$exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";


var $3036eed8c6059f48$var$process = $c1a936bf11afc60d$exports.process;
var $3036eed8c6059f48$var$Deno = $c1a936bf11afc60d$exports.Deno;
var $3036eed8c6059f48$var$versions = $3036eed8c6059f48$var$process && $3036eed8c6059f48$var$process.versions || $3036eed8c6059f48$var$Deno && $3036eed8c6059f48$var$Deno.version;
var $3036eed8c6059f48$var$v8 = $3036eed8c6059f48$var$versions && $3036eed8c6059f48$var$versions.v8;
var $3036eed8c6059f48$var$match, $3036eed8c6059f48$var$version;
if ($3036eed8c6059f48$var$v8) {
    $3036eed8c6059f48$var$match = $3036eed8c6059f48$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $3036eed8c6059f48$var$version = $3036eed8c6059f48$var$match[0] > 0 && $3036eed8c6059f48$var$match[0] < 4 ? 1 : +($3036eed8c6059f48$var$match[0] + $3036eed8c6059f48$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$3036eed8c6059f48$var$version && $03b2a56e52e979c9$exports) {
    $3036eed8c6059f48$var$match = $03b2a56e52e979c9$exports.match(/Edge\/(\d+)/);
    if (!$3036eed8c6059f48$var$match || $3036eed8c6059f48$var$match[1] >= 74) {
        $3036eed8c6059f48$var$match = $03b2a56e52e979c9$exports.match(/Chrome\/(\d+)/);
        if ($3036eed8c6059f48$var$match) $3036eed8c6059f48$var$version = +$3036eed8c6059f48$var$match[1];
    }
}
$3036eed8c6059f48$exports = $3036eed8c6059f48$var$version;




var $f8b28deb16ab50c4$var$$String = $c1a936bf11afc60d$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$f8b28deb16ab50c4$exports = !!Object.getOwnPropertySymbols && !$a33d963e09eb558c$exports(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$f8b28deb16ab50c4$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $3036eed8c6059f48$exports && $3036eed8c6059f48$exports < 41;
});


var $d399e516993446f6$exports = {};
"use strict";

$d399e516993446f6$exports = $f8b28deb16ab50c4$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $ca6d0bcc6f906075$var$Symbol = $c1a936bf11afc60d$exports.Symbol;
var $ca6d0bcc6f906075$var$WellKnownSymbolsStore = $6a3b62422cfbbb41$exports("wks");
var $ca6d0bcc6f906075$var$createWellKnownSymbol = $d399e516993446f6$exports ? $ca6d0bcc6f906075$var$Symbol["for"] || $ca6d0bcc6f906075$var$Symbol : $ca6d0bcc6f906075$var$Symbol && $ca6d0bcc6f906075$var$Symbol.withoutSetter || $72fe204d9ae5bfe5$exports;
$ca6d0bcc6f906075$exports = function(name) {
    if (!$805b3d110a2de9fb$exports($ca6d0bcc6f906075$var$WellKnownSymbolsStore, name)) $ca6d0bcc6f906075$var$WellKnownSymbolsStore[name] = $f8b28deb16ab50c4$exports && $805b3d110a2de9fb$exports($ca6d0bcc6f906075$var$Symbol, name) ? $ca6d0bcc6f906075$var$Symbol[name] : $ca6d0bcc6f906075$var$createWellKnownSymbol("Symbol." + name);
    return $ca6d0bcc6f906075$var$WellKnownSymbolsStore[name];
};


$ecd5b51bbe74d68a$export$2d1720544b23b823 = $ca6d0bcc6f906075$exports;


// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $0ab4bc1e30495d54$export$2d1720544b23b823;
"use strict";
var $14658b4e7098aa03$exports = {};
"use strict";

// Detect IE8's incomplete defineProperty implementation
$14658b4e7098aa03$exports = !$a33d963e09eb558c$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $c434ed2e027e0486$exports = {};
"use strict";


var $12a3f8fe18b57e76$exports = {};
"use strict";

var $b785758b41cbe1eb$exports = {};
"use strict";
var $7006715f7442de50$exports = {};
"use strict";
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $7006715f7442de50$var$documentAll = typeof document == "object" && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$7006715f7442de50$exports = typeof $7006715f7442de50$var$documentAll == "undefined" && $7006715f7442de50$var$documentAll !== undefined ? function(argument) {
    return typeof argument == "function" || argument === $7006715f7442de50$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};


$b785758b41cbe1eb$exports = function(it) {
    return typeof it == "object" ? it !== null : $7006715f7442de50$exports(it);
};


var $12a3f8fe18b57e76$var$document = $c1a936bf11afc60d$exports.document;
// typeof document.createElement is 'object' in old IE
var $12a3f8fe18b57e76$var$EXISTS = $b785758b41cbe1eb$exports($12a3f8fe18b57e76$var$document) && $b785758b41cbe1eb$exports($12a3f8fe18b57e76$var$document.createElement);
$12a3f8fe18b57e76$exports = function(it) {
    return $12a3f8fe18b57e76$var$EXISTS ? $12a3f8fe18b57e76$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$c434ed2e027e0486$exports = !$14658b4e7098aa03$exports && !$a33d963e09eb558c$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($12a3f8fe18b57e76$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


var $042e3f310af785f6$exports = {};
"use strict";


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$042e3f310af785f6$exports = $14658b4e7098aa03$exports && $a33d963e09eb558c$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $680640061bca2232$exports = {};
"use strict";

var $680640061bca2232$var$$String = String;
var $680640061bca2232$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$680640061bca2232$exports = function(argument) {
    if ($b785758b41cbe1eb$exports(argument)) return argument;
    throw new $680640061bca2232$var$$TypeError($680640061bca2232$var$$String(argument) + " is not an object");
};


var $4309e6bcc18c1745$exports = {};
"use strict";
var $b41f80dcd01fd645$exports = {};
"use strict";
var $ceac9471ac353354$exports = {};
"use strict";

var $ceac9471ac353354$var$call = Function.prototype.call;
$ceac9471ac353354$exports = $9026b21e18613bf9$exports ? $ceac9471ac353354$var$call.bind($ceac9471ac353354$var$call) : function() {
    return $ceac9471ac353354$var$call.apply($ceac9471ac353354$var$call, arguments);
};



var $a203dbc04d488852$exports = {};
"use strict";
var $05d8ba5c053ef631$exports = {};
"use strict";


var $05d8ba5c053ef631$var$aFunction = function(argument) {
    return $7006715f7442de50$exports(argument) ? argument : undefined;
};
$05d8ba5c053ef631$exports = function(namespace, method) {
    return arguments.length < 2 ? $05d8ba5c053ef631$var$aFunction($c1a936bf11afc60d$exports[namespace]) : $c1a936bf11afc60d$exports[namespace] && $c1a936bf11afc60d$exports[namespace][method];
};



var $b03438a1a47eb31d$exports = {};
"use strict";

$b03438a1a47eb31d$exports = $4ab7b62f7e4f8a95$exports({}.isPrototypeOf);



var $a203dbc04d488852$var$$Object = Object;
$a203dbc04d488852$exports = $d399e516993446f6$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $05d8ba5c053ef631$exports("Symbol");
    return $7006715f7442de50$exports($Symbol) && $b03438a1a47eb31d$exports($Symbol.prototype, $a203dbc04d488852$var$$Object(it));
};


var $162c2361f2744945$exports = {};
"use strict";
var $527e56cd4cf42273$exports = {};
"use strict";

var $3cde83a37cfac895$exports = {};
"use strict";
var $3cde83a37cfac895$var$$String = String;
$3cde83a37cfac895$exports = function(argument) {
    try {
        return $3cde83a37cfac895$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $527e56cd4cf42273$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$527e56cd4cf42273$exports = function(argument) {
    if ($7006715f7442de50$exports(argument)) return argument;
    throw new $527e56cd4cf42273$var$$TypeError($3cde83a37cfac895$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$162c2361f2744945$exports = function(V, P) {
    var func = V[P];
    return $b6a15a94fe4eb57c$exports(func) ? undefined : $527e56cd4cf42273$exports(func);
};


var $cf057fcdee369ec5$exports = {};
"use strict";



var $cf057fcdee369ec5$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$cf057fcdee369ec5$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $7006715f7442de50$exports(fn = input.toString) && !$b785758b41cbe1eb$exports(val = $ceac9471ac353354$exports(fn, input))) return val;
    if ($7006715f7442de50$exports(fn = input.valueOf) && !$b785758b41cbe1eb$exports(val = $ceac9471ac353354$exports(fn, input))) return val;
    if (pref !== "string" && $7006715f7442de50$exports(fn = input.toString) && !$b785758b41cbe1eb$exports(val = $ceac9471ac353354$exports(fn, input))) return val;
    throw new $cf057fcdee369ec5$var$$TypeError("Can't convert object to primitive value");
};



var $b41f80dcd01fd645$var$$TypeError = TypeError;
var $b41f80dcd01fd645$var$TO_PRIMITIVE = $ca6d0bcc6f906075$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$b41f80dcd01fd645$exports = function(input, pref) {
    if (!$b785758b41cbe1eb$exports(input) || $a203dbc04d488852$exports(input)) return input;
    var exoticToPrim = $162c2361f2744945$exports(input, $b41f80dcd01fd645$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $ceac9471ac353354$exports(exoticToPrim, input, pref);
        if (!$b785758b41cbe1eb$exports(result) || $a203dbc04d488852$exports(result)) return result;
        throw new $b41f80dcd01fd645$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $cf057fcdee369ec5$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$4309e6bcc18c1745$exports = function(argument) {
    var key = $b41f80dcd01fd645$exports(argument, "string");
    return $a203dbc04d488852$exports(key) ? key : key + "";
};


var $0ab4bc1e30495d54$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $0ab4bc1e30495d54$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $0ab4bc1e30495d54$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $0ab4bc1e30495d54$var$ENUMERABLE = "enumerable";
var $0ab4bc1e30495d54$var$CONFIGURABLE = "configurable";
var $0ab4bc1e30495d54$var$WRITABLE = "writable";
$0ab4bc1e30495d54$export$2d1720544b23b823 = $14658b4e7098aa03$exports ? $042e3f310af785f6$exports ? function defineProperty(O, P, Attributes) {
    $680640061bca2232$exports(O);
    P = $4309e6bcc18c1745$exports(P);
    $680640061bca2232$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $0ab4bc1e30495d54$var$WRITABLE in Attributes && !Attributes[$0ab4bc1e30495d54$var$WRITABLE]) {
        var current = $0ab4bc1e30495d54$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$0ab4bc1e30495d54$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $0ab4bc1e30495d54$var$CONFIGURABLE in Attributes ? Attributes[$0ab4bc1e30495d54$var$CONFIGURABLE] : current[$0ab4bc1e30495d54$var$CONFIGURABLE],
                enumerable: $0ab4bc1e30495d54$var$ENUMERABLE in Attributes ? Attributes[$0ab4bc1e30495d54$var$ENUMERABLE] : current[$0ab4bc1e30495d54$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $0ab4bc1e30495d54$var$$defineProperty(O, P, Attributes);
} : $0ab4bc1e30495d54$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $680640061bca2232$exports(O);
    P = $4309e6bcc18c1745$exports(P);
    $680640061bca2232$exports(Attributes);
    if ($c434ed2e027e0486$exports) try {
        return $0ab4bc1e30495d54$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $0ab4bc1e30495d54$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};


var $47e3a6f4aa64529d$require$defineProperty = $0ab4bc1e30495d54$export$2d1720544b23b823;
$47e3a6f4aa64529d$exports = function(NAME) {
    var Symbol = $871f3877c1fafb5a$exports.Symbol || ($871f3877c1fafb5a$exports.Symbol = {});
    if (!$805b3d110a2de9fb$exports(Symbol, NAME)) $47e3a6f4aa64529d$require$defineProperty(Symbol, NAME, {
        value: $ecd5b51bbe74d68a$export$2d1720544b23b823(NAME)
    });
};



var $13affb66ec8327e8$require$defineProperty = $0ab4bc1e30495d54$export$2d1720544b23b823;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $13e31d3f4b5085bf$export$2d1720544b23b823;
"use strict";


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $413f99d05f7b7a55$export$2d1720544b23b823;
"use strict";
var $413f99d05f7b7a55$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $413f99d05f7b7a55$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $413f99d05f7b7a55$var$NASHORN_BUG = $413f99d05f7b7a55$var$getOwnPropertyDescriptor && !$413f99d05f7b7a55$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$413f99d05f7b7a55$export$2d1720544b23b823 = $413f99d05f7b7a55$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $413f99d05f7b7a55$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $413f99d05f7b7a55$var$$propertyIsEnumerable;


var $94ac703e2f7e58c9$exports = {};
"use strict";
$94ac703e2f7e58c9$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $ae3cef39266b3bbf$exports = {};
"use strict";
var $25e86ca138675c52$exports = {};
"use strict";


var $8920a9e6f36cfccd$exports = {};
"use strict";

var $8920a9e6f36cfccd$var$toString = $4ab7b62f7e4f8a95$exports({}.toString);
var $8920a9e6f36cfccd$var$stringSlice = $4ab7b62f7e4f8a95$exports("".slice);
$8920a9e6f36cfccd$exports = function(it) {
    return $8920a9e6f36cfccd$var$stringSlice($8920a9e6f36cfccd$var$toString(it), 8, -1);
};


var $25e86ca138675c52$var$$Object = Object;
var $25e86ca138675c52$var$split = $4ab7b62f7e4f8a95$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$25e86ca138675c52$exports = $a33d963e09eb558c$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$25e86ca138675c52$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $8920a9e6f36cfccd$exports(it) === "String" ? $25e86ca138675c52$var$split(it, "") : $25e86ca138675c52$var$$Object(it);
} : $25e86ca138675c52$var$$Object;



$ae3cef39266b3bbf$exports = function(it) {
    return $25e86ca138675c52$exports($41884dc45663552a$exports(it));
};





// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $13e31d3f4b5085bf$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$13e31d3f4b5085bf$export$2d1720544b23b823 = $14658b4e7098aa03$exports ? $13e31d3f4b5085bf$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $ae3cef39266b3bbf$exports(O);
    P = $4309e6bcc18c1745$exports(P);
    if ($c434ed2e027e0486$exports) try {
        return $13e31d3f4b5085bf$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($805b3d110a2de9fb$exports(O, P)) return $94ac703e2f7e58c9$exports(!$ceac9471ac353354$exports($413f99d05f7b7a55$export$2d1720544b23b823, O, P), O[P]);
};


var $13affb66ec8327e8$require$getOwnPropertyDescriptor = $13e31d3f4b5085bf$export$2d1720544b23b823;
var $13affb66ec8327e8$var$Symbol = $c1a936bf11afc60d$exports.Symbol;
// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-explicit-resource-management
$47e3a6f4aa64529d$exports("dispose");
if ($13affb66ec8327e8$var$Symbol) {
    var $13affb66ec8327e8$var$descriptor = $13affb66ec8327e8$require$getOwnPropertyDescriptor($13affb66ec8327e8$var$Symbol, "dispose");
    // workaround of NodeJS 20.4 bug
    // https://github.com/nodejs/node/issues/48699
    // and incorrect descriptor from some transpilers and userland helpers
    if ($13affb66ec8327e8$var$descriptor.enumerable && $13affb66ec8327e8$var$descriptor.configurable && $13affb66ec8327e8$var$descriptor.writable) $13affb66ec8327e8$require$defineProperty($13affb66ec8327e8$var$Symbol, "dispose", {
        value: $13affb66ec8327e8$var$descriptor.value,
        enumerable: false,
        configurable: false,
        writable: false
    });
}


function $c3c0a900b033074b$var$dispose_SuppressedError(r, e) {
    return "undefined" != typeof SuppressedError ? $c3c0a900b033074b$var$dispose_SuppressedError = SuppressedError : ($c3c0a900b033074b$var$dispose_SuppressedError = function(r, e) {
        this.suppressed = r, this.error = e, this.stack = new Error().stack;
    }, $c3c0a900b033074b$var$dispose_SuppressedError.prototype = Object.create(Error.prototype, {
        constructor: {
            value: $c3c0a900b033074b$var$dispose_SuppressedError,
            writable: !0,
            configurable: !0
        }
    })), new $c3c0a900b033074b$var$dispose_SuppressedError(r, e);
}
function $c3c0a900b033074b$var$_dispose(r, e, s) {
    function next() {
        for(; r.length > 0;)try {
            var o = r.pop(), p = o.d.call(o.v);
            if (o.a) return Promise.resolve(p).then(next, err);
        } catch (r) {
            return err(r);
        }
        if (s) throw e;
    }
    function err(r) {
        return e = s ? new $c3c0a900b033074b$var$dispose_SuppressedError(r, e) : r, s = !0, next();
    }
    return next();
}
function $c3c0a900b033074b$var$_using(o, n, e) {
    if (null == n) return n;
    if (Object(n) !== n) throw new TypeError("using declarations can only be used with objects, functions, null, or undefined.");
    if (e) var r = n[Symbol.asyncDispose || Symbol.for("Symbol.asyncDispose")];
    if (null == r && (r = n[Symbol.dispose || Symbol.for("Symbol.dispose")]), "function" != typeof r) throw new TypeError("Property [Symbol.dispose] is not a function.");
    return o.push({
        v: n,
        d: r,
        a: e
    }), n;
}
class $c3c0a900b033074b$export$cc74486daaaef499 {
    #disposed = false;
    #events = new Map();
    /**
   * Removes an event listener from a target.
   * @param target - The target from which the event listener is to be removed.
   * @param eventName - The name of the event for which the listener is to be removed.
   * @param callback - The callback function to be removed.
   */ #callbackDispose(target, eventName, callback) {
        try {
            target.removeEventListener(eventName, callback);
        } catch (error) {
            //? This is a non-fatal error and could be the result of an early disposal.
            if (error instanceof Error) console.debug(`Failed to remove event listener for target: ${target}. Error: ${error.message}`, {
                cause: error.cause
            });
            else console.debug(`Failed to remove event listener for target: ${target}. An unknown error occurred.`);
        }
    }
    /**
   * Registers an event listener to a target and returns a unique symbol for the registered event.
   * @param target - The target to which the event listener is to be added.
   * @param eventName - The name of the event for which the listener is to be added.
   * @param callback - The callback function to be executed when the event is triggered.
   * @param options - Optional. An options object that specifies characteristics about the event listener.
   * @returns A unique symbol for the registered event.
   * @throws {Error} If an error occurs while removing the event listener during disposal.
   */ register(target, eventName, callback, options) {
        const entry = this.#events.get(target);
        let stack;
        let earlyDisposeMap;
        if (!entry) try {
            var _stack = [];
            const s = $c3c0a900b033074b$var$_using(_stack, new DisposableStack());
            stack = s.move();
            earlyDisposeMap = new Map();
        } catch (_) {
            var _error = _;
            var _hasError = true;
        } finally{
            $c3c0a900b033074b$var$_dispose(_stack, _error, _hasError);
        }
        else {
            stack = entry[0].move();
            earlyDisposeMap = entry[1];
        }
        target.addEventListener(eventName, callback, options);
        stack.defer(()=>{
            console.debug("EventManager disposing event listener:", target, eventName, callback);
            this.#callbackDispose(target, eventName, callback);
        });
        const symbol = Symbol();
        earlyDisposeMap.set(symbol, ()=>{
            console.debug("EventManager disposing early event listener:", target, eventName, callback);
            this.#callbackDispose(target, eventName, callback);
            const entry = this.#events.get(target);
            if (!entry) {
                console.warn(`No event found for target: ${target}`);
                return;
            }
            const currentStack = entry[0].move();
            const currentEarlyDisposeMap = entry[1];
            currentEarlyDisposeMap.delete(symbol);
            currentEarlyDisposeMap.size === 0 ? this.#events.delete(target) : this.#events.set(target, [
                currentStack.move(),
                currentEarlyDisposeMap
            ]);
        });
        this.#events.set(target, [
            stack.move(),
            earlyDisposeMap
        ]);
        return symbol;
    }
    /**
   * Deregisters an event listener from the given event target using the provided symbol.
   * @param target - The event target to remove the event listener from.
   * @param symbol - The unique symbol associated with the event listener.
   * @throws {Error} If no event is found for the provided target.
   * @throws {Error} If deregistration fails for any reason.
   */ deregister(target, symbol) {
        const entry = this.#events.get(target);
        if (!entry) {
            console.warn(`No event listener found for target: ${target} with symbol: ${String(symbol)}`);
            return;
        }
        const [, earlyDisposeMap] = entry;
        const dispose = earlyDisposeMap.get(symbol);
        dispose ? dispose() : console.warn(`No early event listener found for target: ${target} with symbol: ${String(symbol)}`);
    }
    [Symbol.dispose]() {
        if (!this.#disposed) {
            this.#disposed = true;
            for (const [_, entry] of this.#events.entries())entry[0][Symbol.dispose]();
            this.#events.clear();
            console.debug("EventManager disposed.");
        }
    }
}




//# sourceMappingURL=index.js.map
